module.exports = __webpack_public_path__ + "img/35.6ce6406f.png";